import { render, staticRenderFns } from "./view-prefpage-link-modal.vue?vue&type=template&id=7611c0c9"
import script from "./view-prefpage-link-modal.vue?vue&type=script&lang=js"
export * from "./view-prefpage-link-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports